import { Tag, MapPin, ShoppingBag } from "lucide-react";

// Min's Retro & Vintage — Camden · Eclectic, neon, club
export default function MinsAfter({ b }) {
  return (
    <div className="bg-[#1A1A1A] text-[#F0F0F0]">
      <div className="px-6 md:px-10 py-4 flex items-center justify-between border-b border-white/10">
        <div className="font-unbounded font-black text-xl tracking-tight">MIN'S<span className="text-[#D4FF00]">/</span>RETRO</div>
        <nav className="hidden md:flex gap-6 text-[10px] uppercase tracking-[0.25em] font-spacemono text-white/70">
          <span>Drops</span><span>Archive</span><span>Camden</span><span>Stories</span>
        </nav>
        <button className="border border-[#D4FF00] text-[#D4FF00] px-4 py-2 text-[10px] uppercase tracking-[0.25em] font-spacemono">Bag · 0</button>
      </div>

      {/* Hero with neon */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-30 bg-cover bg-center" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1520006403909-838d6b92c22e)" }} />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A1A1A] via-[#1A1A1A]/40 to-[#1A1A1A]" />
        <div className="relative px-6 md:px-10 py-20 md:py-28">
          <p className="font-spacemono uppercase tracking-[0.3em] text-[10px] text-[#D4FF00] mb-6">
            BUCK STREET MKT · CAMDEN NW1 · DROP 047
          </p>
          <h1 className="font-unbounded font-black text-6xl md:text-8xl lg:text-[10rem] leading-[0.85] tracking-tight uppercase">
            One-of-one.<br/>
            <span className="text-[#D4FF00]">No restocks.</span>
          </h1>
          <p className="mt-8 max-w-lg font-spacemono text-sm leading-relaxed text-white/70">
            Hand-picked vintage. 70s denim, 90s Tommy, Y2K bag drops every Wednesday at noon.
            If you see it on this page, it's still on the rack. Just.
          </p>
          <div className="mt-10 flex gap-3">
            <a className="bg-[#D4FF00] text-[#1A1A1A] px-7 py-4 font-unbounded font-black uppercase text-sm tracking-tight">SHOP THE DROP →</a>
            <a className="border border-white text-white px-7 py-4 font-unbounded font-black uppercase text-sm tracking-tight">DROP ALERT</a>
          </div>
        </div>
      </div>

      {/* Product grid */}
      <div className="px-6 md:px-10 py-14 border-y border-white/10">
        <div className="flex items-end justify-between mb-8">
          <h2 className="font-unbounded font-black text-3xl md:text-5xl uppercase">This week's heat.</h2>
          <span className="font-spacemono text-[10px] uppercase tracking-[0.3em] text-[#D4FF00]">04 · LIVE</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            ["Levi's 501 — 32W", "£68", "USA · 1992"],
            ["Tommy Hilfiger Flag Tee", "£42", "1996"],
            ["Carhartt Detroit Jkt", "£135", "Detroit · 90s"],
            ["Y2K Baby Tee", "£28", "Unknown · 2001"],
          ].map(([n, p, t], i) => (
            <div key={i} className="group bg-[#0f0f0f] border border-white/10 hover:border-[#D4FF00] transition-colors">
              <div className="aspect-square bg-cover bg-center" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1520006403909-838d6b92c22e)`, filter: `hue-rotate(${i * 90}deg) saturate(${1 + i * 0.3})` }} />
              <div className="p-3">
                <div className="font-unbounded font-bold text-sm uppercase truncate">{n}</div>
                <div className="flex justify-between mt-1 font-spacemono text-[10px] uppercase tracking-wider text-white/50">
                  <span>{t}</span>
                  <span className="text-[#D4FF00]">{p}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Tourist mode banner */}
      <div className="bg-[#D4FF00] text-[#1A1A1A] px-6 md:px-10 py-6 flex flex-wrap items-center justify-between gap-4">
        <div className="font-unbounded font-black text-2xl uppercase">
          Open today · 11–18 · 6 min walk from Camden Town tube
        </div>
        <span className="font-spacemono text-xs uppercase tracking-[0.3em]">⏱ LIVE</span>
      </div>

      {/* Visit */}
      <div className="px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-8 font-spacemono text-sm">
        <div>
          <Tag className="w-5 h-5 text-[#D4FF00] mb-3" />
          <p className="text-white/60 uppercase tracking-[0.2em] text-[10px] mb-2">DROP SCHEDULE</p>
          <p>Wednesdays · 12:00 · Newsletter first</p>
        </div>
        <div>
          <ShoppingBag className="w-5 h-5 text-[#D4FF00] mb-3" />
          <p className="text-white/60 uppercase tracking-[0.2em] text-[10px] mb-2">SHIPPING</p>
          <p>UK £4.50 · EU £12 · Tracked.</p>
        </div>
        <div>
          <MapPin className="w-5 h-5 text-[#D4FF00] mb-3" />
          <p className="text-white/60 uppercase tracking-[0.2em] text-[10px] mb-2">FIND THE STALL</p>
          <p>{b.address}</p>
        </div>
      </div>
    </div>
  );
}
